// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileNoticeRegister_backIcon__aHb1S","regiBtn":"AdminMobileNoticeRegister_regiBtn__vrHSr","noticeContentInput":"AdminMobileNoticeRegister_noticeContentInput__KN4I8"};